import { Badge } from "@/components/ui/badge";
import type { EchoflicksVideoSession } from "../types";
import { isTestEcho, testEchoTooltip } from "./attribution";

/**
 * 🧪 marker for an Echo the test-echo autoqueue launched (plan
 * 2026-09-02-test-echo-autoqueue §3.6 / TEQ-011). These are synthetic-but-real
 * admin runs: they walk the whole production pipeline, so without a marker an
 * operator cannot tell them apart from customer traffic in the Echoes list.
 *
 * Renders nothing at all unless `echo_origin === "test_autoqueue"` — an absent
 * field is an ordinary Echo, which is every Echo made before this feature and
 * every Echo on a backend that does not project the field.
 *
 * The seed pack and the operator's free-text label ride in the tooltip rather
 * than the badge, so row height and the badge row stay unchanged.
 */
export const TestEchoBadge = ({
  record,
}: {
  record?: Pick<
    EchoflicksVideoSession,
    "echo_origin" | "test_pack_id" | "test_label"
  > | null;
}) => {
  if (!isTestEcho(record)) return null;

  const title = testEchoTooltip(record);

  return (
    <Badge
      variant="outline"
      className="border-dashed"
      title={title ?? undefined}
      aria-label={title ? `Test Echo — ${title}` : "Test Echo"}
    >
      🧪 Test Echo
    </Badge>
  );
};
